import { IconBase, IconBaseProps } from 'react-icons';

import { IconManifest } from 'app/agriculture/icons/types';

const temperatureIcon: IconManifest = {
    id: 'temperature-icon',
    width: 128,
    height: 128,
    d: 'M53.159 20.402a15.03 15.03 0 0 1 25.657 10.627v41.057a22.787 22.787 0 1 1-30.059 0V31.03a15.03 15.03 0 0 1 4.402-10.628Zm10.627 6.265a4.363 4.363 0 0 0-4.362 4.362v43.672c0 1.782-.89 3.445-2.37 4.435a12.119 12.119 0 0 0 12.314 20.835 12.119 12.119 0 0 0 1.152-20.835 5.334 5.334 0 0 1-2.37-4.435V31.03a4.363 4.363 0 0 0-4.364-4.363Z',
};

export function TemperatureIcon(props: IconBaseProps) {
    const { id, d } = temperatureIcon;

    return (
        <IconBase id={id} {...props} viewBox="16 16 96 96" data-testid="TemperatureIcon">
            <path d={d} fill="currentColor" />
        </IconBase>
    );
}
